/* eslint-disable no-unused-vars */
import React from 'react';
import { NavLink } from 'react-router-dom';

import {
  UilCreateDashboard,
  UilUsersAlt,
  UilBell,
  UilBookmark,
  UilSuitcaseAlt,
  UilNewspaper,
  UilUniversity,
  UilBookAlt,
  UilCreditCard,
  UilListOl,
  UilEditAlt,
  UilConstructor,
  UilServers
} from '@iconscout/react-unicons';

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const mMenu = [
  getItem(<NavLink to="/dashboard">Dashboard</NavLink>, 'dashboard', <UilCreateDashboard />, null, 'badge'),

  // getItem('Dashboard', 'dashboard', <UilCreateDashboard />, [
  //   getItem(<NavLink to="/dashboard">Demo 1</NavLink>, '', null),
  //   getItem(<NavLink to="/demo-2">Demo 2</NavLink>, 'demo-2', null),
  //   getItem(<NavLink to="/demo-3">Demo 3</NavLink>, 'demo-3', null),
  //   getItem(<NavLink to="/demo-4">Demo 4</NavLink>, 'demo-4', null),
  //   getItem(<NavLink to="/demo-5">Demo 5</NavLink>, 'demo-5', null),
  //   getItem(<NavLink to="/demo-6">Demo 6</NavLink>, 'demo-6', null),
  //   getItem(<NavLink to="/demo-7">Demo 7</NavLink>, 'demo-7', null),
  //   getItem(<NavLink to="/demo-8">Demo 8</NavLink>, 'demo-8', null),
  //   getItem(<NavLink to="/demo-9">Demo 9</NavLink>, 'demo-9', null),
  //   getItem(<NavLink to="/demo-10">Demo 10</NavLink>, 'demo-10', null),
  // ]),

  getItem('Companies', 'Companies', <UilSuitcaseAlt />, [
    getItem(<NavLink to="/companies">List All</NavLink>, '', null),
    getItem(<NavLink to="/comp-fps">Focal Persons</NavLink>, 'comp-fps', null),
    getItem(<NavLink to="/comp-addresses">Addresses</NavLink>, 'comp-addresses', null),
    getItem(<NavLink to="/comp-atts">Attachments</NavLink>, 'comp-atts', null),
  ]),
  getItem(<NavLink to="/users">Users</NavLink>, 'users', <UilUsersAlt />, null, 'badge'),
  getItem(<NavLink to="/t-centers">Training Centers</NavLink>, 't-centers', <UilUniversity />, null, 't-centers'),
  getItem(<NavLink to="/t-courses">Courses</NavLink>, 't-courses', <UilNewspaper />, null, 't-courses'),
  getItem(<NavLink to="/emps">Employees</NavLink>, 'emps', <UilConstructor />, null, 'emps'),
  // getItem(<NavLink to="/notifications">Notifications <span className='badge bg-red-400 !p-[4px] menuItem animate-pulse'> 1000 </span></NavLink>, 'notifications', <UilBell />, null, 'notifications'),
  getItem(<NavLink to="/emp-trainings">EMP Trainings</NavLink>, 'trainings', <UilBookAlt />, null, 'trainings'),
  getItem(<NavLink to="/e-cards">EMP Cards</NavLink>, 'cards', <UilCreditCard />, null, 'cards'),
  getItem(<NavLink to="/designations">Designations</NavLink>, 'designations', <UilServers />, null, 'designations'),
  getItem(<NavLink to="/notifications">Notifications</NavLink>, 'notifications', <UilBell />, null, 'notifications'),
  getItem(<NavLink to="/c-validity">Cards Validity</NavLink>, 'c-validity', <UilBookmark />, null, 'c-validity'),
  getItem(<NavLink to="/n-series">Number Series</NavLink>, 'n-series', <UilListOl />, null, 'n-series'),
  getItem(<NavLink to="/signatures">Signatures</NavLink>, 'signatures', <UilEditAlt />, null, 'signatures'),
];

export default mMenu